import httpClient from '@/libs/http-client'

export function bettingList (params) {
  const url = '/api/bet/betlistNew'
  return httpClient.post(url, params).then(response => {
    return response
  })
}

export function bettingDetail (params) {
  return httpClient.post('/api/bet/betDetail', params)
}

// 상세 페이지용 토큰만 전달한다. 사이트 API 키와 로그인 토큰은 전송하지 않는다.
export async function inplayBetSummary (detailUrl) {
  const url = new URL(detailUrl)
  if (url.origin !== 'https://sports.ggmetricsapi.com' || url.pathname !== '/bet-detail') throw new Error('INVALID_DETAIL_URL')
  const token = new URLSearchParams(url.hash.slice(1)).get('token')
  if (!token) throw new Error('MISSING_DETAIL_TOKEN')
  const response = await fetch('/api/inplay-bet-summary', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
    credentials: 'omit',
    cache: 'no-store',
    referrerPolicy: 'no-referrer',
    signal: AbortSignal.timeout(15000)
  })
  if (!response.ok) throw new Error('SUMMARY_FAILED')
  const data = await response.json()
  if (!data || !Array.isArray(data.positions)) throw new Error('INVALID_SUMMARY')
  return data
}
